/**
 * 是否浏览器环境
 */
export const isBrowser = typeof window !== 'undefined' && typeof window.window !== 'undefined';
/**
 * 是否 SSR 运行时环境
 */
export const isSSREnv = process.env.REACT_APP_isBrowser === 'false';
